export const URI_SIGN_IN = 'auth/sign-in';
export const URI_SIGN_UP = 'auth/sign-up';
export const URI_SEND_CODE = 'auth/send-code';
export const URI_CONFIRM_ACCOUNT = 'auth/confirm/account';
export const URI_CONFIRM_EMPLOYEE = 'auth/confirm/employee';
export const URI_RESET_PASSWORD = 'auth/reset-password';
export const URI_SIMPLE_SIGN_UP = 'auth/registration/simple';
